// src/components/Button/Button.jsx
import React from "react";

const Button = ({ children, variant = "primary", onClick, className = "" }) => {
  const baseClasses =
    "inline-flex items-center justify-center px-5 py-2.5 sm:px-6 sm:py-3 rounded-xl font-semibold transition-all duration-300 ease-out text-sm sm:text-base focus:outline-none focus-visible:ring-4 focus-visible:ring-blue-200 active:scale-[0.98]";
  const variantClasses = {
    primary:
      "bg-[#3f6fe5] hover:bg-[#2f5fd8] text-white shadow-lg shadow-[#3f6fe5]/20 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-[#3f6fe5]/25",
    secondary:
      "bg-white hover:bg-[#eef4ff] text-[#2458d3] border border-white/80 shadow-lg shadow-[#3f6fe5]/15 hover:-translate-y-0.5",
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
